import { useQuery } from '@tanstack/react-query';
import { client } from '../../../../util/api';
import {
  MEMBER_JOURNEY_QUERY_KEY,
  memberJourneyPath,
  MemberJourneyProjection,
} from './journeyReportModel';

/**
 * The stored journey projection for one member. Disabled when `memberId` is
 * empty; never retries, so a 404 (no snapshot yet) surfaces as an error.
 */
export const useMemberJourneyProjection = (memberId: string) =>
  useQuery({
    queryKey: [...MEMBER_JOURNEY_QUERY_KEY, memberId],
    queryFn: async (): Promise<MemberJourneyProjection> => {
      const response = await client.get<MemberJourneyProjection>(
        memberJourneyPath(memberId),
      );
      return response.data;
    },
    enabled: Boolean(memberId),
    retry: false,
    refetchOnWindowFocus: false,
  });
